// Umami custom event tracking is disabled to prevent heavy database write load on the server.
// Standard pageviews can still be tracked by the script tag if loaded.

export const trackUmamiEvent = () => {
  // No-op to keep Umami database light and prevent event bloat.
};

export const trackFormSubmit = () => {
  // No-op to keep Umami database light and prevent event bloat.
};
